import { fetchConToken } from "../helpers/fetch";

const tipos = async () => {
  const resp = await fetchConToken(
    `tipo/`
  );
  const body = await resp.json();

  return body;
};

const tipoxid = async (id) => {
    const resp = await fetchConToken(
        `tipo/tipoxid/`,
        {idtipo: id},
        "POST"
      );
      const body = await resp.json();      
    
      return body;
};

export {
    tipos,
    tipoxid
};